<template>
  <!-- the popover's own trigger is the button: no button in a button -->
  <StatusPopover
    v-if="statusId && !plain"
    :status-id="statusId"
    class="reply-arrow-popover"
    @click="goto"
  >
    <span
      class="reply-arrow"
      role="img"
      :aria-label="$t('status.reply_to')"
    >
      <FAIcon
        icon="reply"
        flip="horizontal"
      />
    </span>
  </StatusPopover>
  <span
    v-else
    class="reply-arrow"
    :class="{ '-strikethrough': !statusId }"
    role="img"
    :aria-label="$t('status.reply_to')"
  >
    <FAIcon
      icon="reply"
      flip="horizontal"
    />
  </span>
</template>

<script>
import { defineAsyncComponent } from 'vue'

// The "reply to" arrow in front of a reply's first mention, when that
// mention is the replied-to person: it stands in for the "Reply to" line.
// Hovering shows the replied-to post; a click goes to it in a thread.
export default {
  components: {
    // the popover shows a post, which has rich content: no import cycle
    StatusPopover: defineAsyncComponent(
      () => import('src/components/status_popover/status_popover.vue'),
    ),
  },
  inject: {
    gotoReplyParent: { default: null },
  },
  props: {
    // the replied-to post, or nothing when it cannot be seen
    statusId: { type: String, default: null },
    // only the icon: inside a hover preview, no popover in a popover
    plain: Boolean,
  },
  methods: {
    goto() {
      this.gotoReplyParent?.()
    },
  },
}
</script>

<style lang="scss">
.reply-arrow-popover {
  display: inline;
}

.reply-arrow {
  display: inline-flex;
  margin-right: 0.3em;
  color: var(--textFaint);
  vertical-align: baseline;

  &.-strikethrough {
    opacity: 0.6;
  }
}
</style>
